import { RootState } from '..';
import { newsFeedEntityAdapters } from './newsFeedEntityAdapters';

export const newsFeedSelectors = newsFeedEntityAdapters.posts.getSelectors<RootState>(state => state.newsFeed.posts);
